export enum SituacaoAlunoCertificacao {
  Aprovado = 'Aprovado',
  Reprovado = 'Reprovado',
  Emandamento = 'Emandamento'
}

export interface DadosPesquisaAlunoCertificacao {
  cpf: string
  nome: string
  email: string
  situacao: SituacaoAlunoCertificacao
  turmaCertificacaoId: string
  usuarioPerfilFiltro: string
  dataCriacaoAluno: string
}

export interface DadosPesquisaProfessorCertificacao {
  cpf: string
  nome: string
  email: string
  situacao: SituacaoAlunoCertificacao
  turmaCertificacaoId: string
  usuarioPerfilFiltro: string
  dataCriacaoProfessor: string
}

export enum AlunoCertificacaoSituacao {
  Aprovado,
  Reprovado,
  Emandamento,
  Todos
}

export enum AlunoStatusCertificado {
  Aguardando,
  Entregue,
  Cursando
}

export enum OpcoesBoolAluno {
  Sim = 'Sim',
  Nao = 'Nao'
}
